export default __webpack_public_path__ + "static/media/gain-visi.1844f6fb.svg";